import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>High-Quality Cruise Leads for Travel Agents</h1>
            <p className="hero-subtitle">
              Pay per call, no monthly fees. Connect with motivated cruise shoppers from our
              engaged community of cruise enthusiasts.
            </p>
            <div className="hero-cta">
              <Link to="/contact" className="btn btn-large btn-primary">Apply Now</Link>
              <Link to="/for-agents" className="btn btn-large btn-secondary">Learn More</Link>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2>How It Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Apply & Get Approved</h3>
              <p>Quick manual review process to ensure quality standards</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Set Your Availability</h3>
              <p>Toggle available/unavailable anytime via our app</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Receive Calls</h3>
              <p>High-intent cruise shoppers routed to you in real-time</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Book & Earn</h3>
              <p>Convert leads, keep 100% of commissions, get billed monthly</p>
            </div>
          </div>
        </div>
      </section>

      {/* Value Propositions */}
      <section className="value-props">
        <div className="container">
          <h2>Why Travel Agents Love Us</h2>
          <div className="props-grid">
            <div className="prop-card">
              <h3>💰 No Monthly Fees</h3>
              <p>
                Pay only per call. No $500-2000/month subscriptions like competitors.
                Zero risk, zero commitment.
              </p>
            </div>
            <div className="prop-card">
              <h3>🎯 High Quality Leads</h3>
              <p>
                10-30% conversion rates vs 2-8% industry average. Real people actively
                looking to book cruises.
              </p>
            </div>
            <div className="prop-card">
              <h3>⚡ Real-Time Routing</h3>
              <p>
                Live calls connect instantly. Not days-old leads that have been sold to
                10 other agents.
              </p>
            </div>
            <div className="prop-card">
              <h3>🏆 Lead Ownership</h3>
              <p>
                Once you take a call, that customer is yours forever. All follow-up calls
                are FREE.
              </p>
            </div>
            <div className="prop-card">
              <h3>🎮 Complete Control</h3>
              <p>
                Toggle availability on/off anytime. Control your spend, your schedule,
                your business.
              </p>
            </div>
            <div className="prop-card">
              <h3>📊 Full Transparency</h3>
              <p>
                Call recordings, real-time dashboard, detailed billing. Know exactly what
                you're paying for.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Overview */}
      <section className="pricing-overview">
        <div className="container">
          <h2>Simple, Transparent Pricing</h2>
          <div className="pricing-cards">
            <div className="pricing-card">
              <h3>Standard Calls</h3>
              <div className="price">$5<span>/call</span></div>
              <p>Social media traffic</p>
              <ul>
                <li>14M+ followers</li>
                <li>High-intent shoppers</li>
                <li>Real-time routing</li>
                <li>Lead ownership</li>
              </ul>
            </div>
            <div className="pricing-card featured">
              <div className="badge">Most Popular</div>
              <h3>Premium Calls</h3>
              <div className="price">$15<span>/call</span></div>
              <p>Email list subscribers</p>
              <ul>
                <li>10K+ engaged subscribers</li>
                <li>Higher conversion rates</li>
                <li>More qualified leads</li>
                <li>Priority routing</li>
              </ul>
            </div>
          </div>
          <p className="pricing-note">
            Only pay for calls 90+ seconds with legitimate cruise inquiries. No monthly fees,
            no contracts, cancel anytime.
          </p>
          <Link to="/pricing" className="btn btn-primary">See Full Pricing Details</Link>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <div className="container">
          <h2>What Agents Are Saying</h2>
          <div className="testimonial-grid">
            <div className="testimonial-card">
              <p className="quote">
                "The conversion rate is incredible. I'm booking 1 in 4 calls. Way better than
                Facebook leads I was buying for twice the price."
              </p>
              <p className="author">— Sarah M., Independent Travel Advisor</p>
            </div>
            <div className="testimonial-card">
              <p className="quote">
                "I love that I can toggle off when I'm busy and back on when I need leads.
                Total control over my marketing spend."
              </p>
              <p className="author">— Michael R., Cruise Specialist</p>
            </div>
            <div className="testimonial-card">
              <p className="quote">
                "These are real people who want to book NOW. Not tire-kickers. Worth every penny."
              </p>
              <p className="author">— Jennifer L., Travel Agent</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta">
        <div className="container">
          <h2>Ready to Grow Your Cruise Business?</h2>
          <p>Join our network of successful travel agents. No contracts, no risk.</p>
          <Link to="/contact" className="btn btn-large btn-primary">Apply Now</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
